lastLineStart